import React from 'react';
import { type StyleProp, type ViewStyle } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useSkeletonContext } from './SkeletonGroup';
import { useSkeletonPulse } from './useSkeletonPulse';
import { useSkeletonBoneColor } from './skeletonColors';

interface SkeletonBoneProps {
  width: number | `${number}%`;
  height: number;
  borderRadius?: number;
  style?: StyleProp<ViewStyle>;
}

export const SkeletonBone: React.FC<SkeletonBoneProps> = React.memo(({
  width,
  height,
  borderRadius = 6,
  style,
}) => {
  const context = useSkeletonContext();
  const fallbackOpacity = useSkeletonPulse();
  const defaultBoneColor = useSkeletonBoneColor();
  const opacity = context?.opacity ?? fallbackOpacity;
  const boneColor = context?.boneColor ?? defaultBoneColor;

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  return (
    <Animated.View
      style={[
        { width, height, borderRadius, backgroundColor: boneColor },
        animatedStyle,
        style,
      ]}
    />
  );
});

SkeletonBone.displayName = 'SkeletonBone';
